"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yAxisStyle = exports.xAxisStyle = exports.borderStyle = void 0;

/* eslint-disable import/prefer-default-export */
var xAxisStyle = {
  height: 100,
  line: {
    stroke: '#B1B1B1',
    strokeWidth: '1px'
  },
  text: {
    color: '#171717',
    fontSize: 14
  },
  ticks: {
    line: {
      stroke: 'none'
    }
  }
};
exports.xAxisStyle = xAxisStyle;
var yAxisStyle = {
  line: {
    stroke: 'none'
  }
};
exports.yAxisStyle = yAxisStyle;
var borderStyle = {
  bottom: {
    fill: '#fff'
  },
  left: {
    fill: '#fff'
  },
  right: {
    fill: '#fff'
  },
  top: {
    fill: 'transparent'
  }
};
exports.borderStyle = borderStyle;